export const edgeExtURL = 'https://microsoftedge.microsoft.com/addons/detail/uet-tag-helper-by-micros/nmcihgehpmokipeigjpeckphhdejjpbf';
export const chromeExtURL = 'https://chrome.google.com/webstore/detail/uet-tag-helper-by-bing-ad/naijndjklgmffmpembnkfbcjbognokbf';
